export default {
  darker: "#CC444B",
  dark: "#DA5552",
  mid: "#DF7373",
  light: "#E39695",
  lighter: "#E4B1AB",
  midTransparent: "rgba(223,115,115, 0.8)",
  lightTransparent: "rgba(227,150,149, 0.8)"
};
